export const EMOJI_REACTIONS = [
	{ emoji: "🔥", label: "Fire" },
	{ emoji: "❤️", label: "Love" },
	{ emoji: "👏", label: "Clap" },
	{ emoji: "🙌", label: "Hands up" },
	{ emoji: "💯", label: "Perfect" },
	{ emoji: "😂", label: "Funny" },
	{ emoji: "😍", label: "Love it" },
	{ emoji: "🤯", label: "Mind blown" },
	{ emoji: "🙏", label: "Thank you" },
	{ emoji: "👀", label: "Watching" },
] as const;

export type EmojiReaction = (typeof EMOJI_REACTIONS)[number];
export type ReactionEmoji = EmojiReaction["emoji"];
